import React, { useEffect, useState } from "react";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { getCustomers } from "../../features/cart/service/Customers.service"; // update path

const SelectCustomer = ({
  dealerId = 982,
  type = "customer",
  value,
  onChange,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadCustomers = async (search = "") => {
    setLoading(true);

    const customers = await getCustomers({
      dealerId,
      q: search,
      type,
    });

    const list = customers.map((item) => ({
      value: item.id,
      label: item.accountName,
      customer: item,
    }));

    setOptions(list);
    setLoading(false);
  };

  useEffect(() => {
    loadCustomers();
  }, []);

  return (
    <Select
      options={options}
      value={value}
      isSearchable
      isLoading={loading}
      placeholder="Select Customer"
      className="react-select-container"
      classNamePrefix="react-select"
      onInputChange={(input) => {
        loadCustomers(input);
      }}
      onChange={(option) => {
        onChange(option.customer);
      }}
    />
  );
};

export default SelectCustomer;